// interface SessionSecurityBarProps {
//   isTerminalReady: boolean;
//   secondsRemaining: number;
// }

// function formatCountdown(totalSeconds: number) {
//   const safeSeconds = Math.max(0, totalSeconds);
//   const minutes = Math.floor(safeSeconds / 60);
//   const seconds = safeSeconds % 60;
//   return `${minutes}:${seconds.toString().padStart(2, '0')}`;
// }

export function SessionSecurityBar(
  // { isTerminalReady, secondsRemaining }: SessionSecurityBarProps
  ) {
  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
      <div className="d-flex flex-wrap align-items-center gap-3">
        <span className="text-body-sm text-on-surface-variant d-flex align-items-center gap-1">
          <i className="bi bi-lock-fill text-primary" />
          256-bit Secure Gateway
        </span>
        {/* <span className="text-body-sm text-on-surface-variant d-flex align-items-center gap-1">
          <span
            className={`rounded-circle ${isTerminalReady ? 'bg-success' : 'bg-danger'}`}
            style={{ width: 8, height: 8 }}
          />
          Terminal {isTerminalReady ? 'Ready' : 'Offline'}
        </span> */}
      </div>

      {/* <span className="badge bg-surface-container text-on-surface-variant fw-medium d-flex align-items-center gap-1">
        <i className="bi bi-hourglass-split" />
        Kiosk reserved · {formatCountdown(secondsRemaining)}
      </span> */}
    </div>
  );
}
